import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './historyDialog.scss';
import { useAuth } from '@/lib/auth'
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as Statusicon } from '@/assets/steam/funnel-frame.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/date-frame.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import { ReactComponent as ProductIconWithBg } from '@/assets/steam/product-with-bg.svg';
import Utils from '@/utils/util';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetFunnelStagess } from '../api/getStages';
import { useGetProductGroupList, useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import { ReactComponent as ArchiveFunnel } from '@/assets/steam/archive.svg';

const FullHistoryComponent: VFC<{
    funnetType?: any;
    selectedFunnel?: any;
    details?: any;
    reduceFont?: boolean;
    usersListData: any;
    productList:any;
}> = ({ funnetType, selectedFunnel, details, reduceFont = false, usersListData, productList }) => {
    const { user } = useAuth();
    const useGetUsersMutation = useGetUsersList();
    const [usersList, setUsersList] = useState<User[]>([]);
    const useGetFunnelStagessMutation = useGetFunnelStagess();
    const [funnelStages, setFuneelStages] = useState<[]>([]);
    const [allProductList, setAllProductsList] = useState<Product[]>([]);
    const [productsGroupList, setAllProductsGroupList] = useState<any[]>([]);
    const useGetProductMutation = useGetProductList();
    const useGetProductGroupMutation = useGetProductGroupList();

    useEffect(() => {
        //getUsersList(1);
        //getProductList();
        if (selectedFunnel) {
            getProductsGroupList();
        }
        if (funnetType) {
            getFunnelStages(funnetType);
        }
    }, [funnetType])

    useEffect(()=>{
        setUsersList(usersListData ? usersListData : []);
    },[usersListData])

    const getProductList = async () => {
        const res = await useGetProductMutation.mutateAsync({
            page: 1,
            perPage: 100,
            search: '',
            filter: '',
        });

        setAllProductsList(res.list)

    };

    const getProductsGroupList = async () => {
        const res = await useGetProductGroupMutation.mutateAsync({
            funnelId: selectedFunnel.id
        });

        setAllProductsGroupList(res.productGroupData)

    };
    const getFunnelStages = async (id: any) => {
        const res = await useGetFunnelStagessMutation.mutateAsync({
            id: Number(id)
        });

        if (res) {
            setFuneelStages(res.list)
        }
    }

    const getUsersList = async (pageIndex: number, reset = false, filter?: any) => {
        const res = await useGetUsersMutation.mutateAsync({
            page: pageIndex,
            perPage: 500,
            search: '',
            filter: { 'rolesId': [1, 2, 3, 4] },
        });
        setUsersList(res.list);

    };


    const getStageName = (stageId: any) => {
        const data: any = funnelStages.filter((item: any) => Number(item.id) === Number(stageId))
        if (data && data.length > 0) {
            return data[0].name
        } else {
            return 'Initial Sampling'
        }

    }

    const getProductName = (id: any) => {
        const getProductName = productsGroupList && productsGroupList.length > 0 && productsGroupList.filter((item: any) => Number(item.id) === Number(id));
        if (getProductName && getProductName.length > 0) {
            return getProductName[0].product.name
        } else {
            return ''
        }

    }


    const getTitleName = (item: any, fieldName: string) => {

        if (item.tableName === 'funnel') {
            if (item.fieldName === 'dealSize') {
                return 'Funnel dealsize updated'
            } else if (item.fieldName === "followUpDate") {
                return 'Funnel follow up date updated'
            } else if (item.fieldName === "coverageDate") {
                return 'Funnel coverage date updated'
            } else if (item.fieldName === "stageId") {
                return 'Funnel state updated'
            } else if (item.fieldName === "comments") {
                return 'Coverage details updated'
            }else if(fieldName === "isArchived" ){
                return 'This funnel was archived'
          }
             else {
                return ''
            }
        } else if (item.tableName === "product_group") {
            return ''
        } else if (item.tableName === "contact") {
            return 'Contacts updated'
        }

    }



    const getProductClassNames = (classIds: number[]) => {
        const classNames: string[] = [];

        classIds?.forEach((classId) => {
            allProductList?.forEach((product: any) => {
                product.subject?.forEach((subject: any) => {
                    subject.classes?.forEach((classItem: any) => {
                        if (parseInt(classItem.id) === Number(classId)) {
                            classNames.push(classItem.name);
                        }
                    });
                });
            });
        });
        return classNames.join(', ');
    };

    const getProductSubjectNames = (subjectIds: number[]) => {
        const classNames: string[] = [];

        subjectIds?.forEach((subjectId) => {
            allProductList?.forEach((product: any) => {
                product.subject?.forEach((subject: any) => {
                    if (parseInt(subject.id) === Number(subjectId)) {
                        classNames.push(subject.name);
                    }
                });
            });
        });
        return classNames.join(', ');

    };


    const gethistoryIcon = (tableName: any, fieldName: any) => {
        if (tableName === 'funnel') {
            if (fieldName === "dealSize") {
                return <ProductIconWithBg />
            } else if (fieldName === "followUpDate") {
                return < Calendericon />
            } else if (fieldName === "coverageDate") {
                return < Coverageicon />
            } else if (fieldName === "stageId") {
                return < Statusicon />
            } else if(fieldName === "isArchived" ){
                  return <ArchiveFunnel />
            }else {
                return  null
            }
        } else if (tableName === "contact") {
            return < Coverageicon />
        }

    }

    const groupByPk = (details: any) => {
        return details.reduce((acc: any, item: any) => {
            if (!acc[item.pk]) {
                acc[item.pk] = [];
            }
            acc[item.pk].push(item);
            return acc;
        }, {});
    };


    const getAllFunnelHistoryDetails = (details: any) => {
        if (!details || details.docs.length === 0) return null;

        const groupedData = details.docs.reduce((acc: any, item: any) => {
            if (!acc[item.tableName]) {
                acc[item.tableName] = [];
            }
            acc[item.tableName].push(item);
            return acc;
        }, {});

        const groupedByPk = groupByPk(details.docs);


        return (
            <>
                {Object.keys(groupedByPk).map((pk) => {
                    const items = groupedByPk[pk];
                    if (items.length === 0) return null;
                    const hasNoProductData = items.every((item: any) => item.tableName !== 'product_group');
                    if (hasNoProductData) {
                      return null; 
                    }
                    return (
                        <>
                            <div key={pk} className={`history-mapping-group ${items.length === 0 ? '' : 'mb-4'}`}>

                                {items && items.length > 0 && <div className={`product-history-doc  ${reduceFont ? 'reduce-font' : 'mb-2'}`}>
                                    <div className={`product-history-title ${reduceFont ? 'reduce-font' : ' '} `}>
                                        <ProductIconWithBg />
                                        <div className={`history-mapping-name  ${reduceFont ? 'reduce-font' : ' '}`}>
                                            {getProductName(pk)}
                                        </div>
                                    </div>
                                    <div className='vertical-line'></div>

                                </div>}



                                
                                {items.map((item: any, index: number) => (
                                    <div key={index} className={`history-mapping increase-padding add-margin-left ${reduceFont ? 'reduce-font' : ''}`}>
                                        <div className="details-div">
                                            {item.action === "delete" && (
                                                <div className="ttile display-set prod-deleted">
                                                    This product was removed.
                                                </div>
                                            )}

                                            {item.fieldName === "subject" && (
                                                <div className={`ttile display-set  ${reduceFont ? 'reduce-font' : ' '}`}>
                                                    Subjects {item.action === 'create' ? 'added' : 'updated'}
                                                    <div className="display-detail mb-less">
                                                        {item.action === 'upsert' && (
                                                            <>
                                                                <span>{getProductSubjectNames(item.oldValue)}</span>{" -> "}
                                                            </>
                                                        )}
                                                        <span className="pro">{getProductSubjectNames(item.newValue)}</span>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Class Field */}
                                            {item.fieldName === "class" && (
                                                <div className={`ttile display-set  ${reduceFont ? 'reduce-font' : ' '}`}>
                                                    Classes {item.action === 'create' ? 'added' : 'updated'}
                                                    <div className="display-detail mb-less">
                                                        {item.action === 'upsert' && (
                                                            <>
                                                                <span>{getProductClassNames(item.oldValue)}</span> {"-> "}
                                                            </>
                                                        )}
                                                        <span className="pro">{getProductClassNames(item.newValue)}</span>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Price Field */}
                                            {item.fieldName === "price" && (
                                                <div className={`ttile display-set  ${reduceFont ? 'reduce-font' : ' '}`}>
                                                    Price {item.action === 'create' ? 'added' : 'updated'}
                                                    <div className="display-detail mb-less">
                                                        {item.action === 'upsert' && (
                                                            <>
                                                                <span>{Utils.convertDealSize(Number(item.oldValue))}</span> {"-> "}
                                                            </>
                                                        )}
                                                        <span className="pro">{Utils.convertDealSize(Number(item.newValue))}</span>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Quantity Field */}
                                            {item.fieldName === "quantity" && (
                                                <div className={`ttile display-set  ${reduceFont ? 'reduce-font' : ' '}`}>
                                                    Quantity {item.action === 'create' ? 'added' : 'updated'}
                                                    <div className="display-detail mb-less">
                                                        {item.action === 'upsert' && (
                                                            <>
                                                                <span>{item.oldValue}</span> {"-> "}
                                                            </>
                                                        )}
                                                        <span className="pro">{item.newValue}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                           
                        </>
                    );
                })}

                {Object.keys(groupedData).map((tableName) => {
                    if (tableName !== "product_group") {
                        return groupedData[tableName].map((item: any) => (
                            <div key={item._id} className={`history-mapping-group ${reduceFont ? 'reduce-font' : ''}`}>
                                {item.tableName !== "contact" &&  <div className={`product-history-doc  ${reduceFont ? 'reduce-font' : 'mb-2'}`}>
                                    <div className={`product-history-title ${reduceFont ? 'reduce-font' : ''}`}>
                                        {gethistoryIcon(item.tableName, item.fieldName)}
                                        <div className={`history-mapping-name ${reduceFont ? 'reduce-font' : ''}`}>
                                            {getTitleName(item, item.fieldName)}
                                        </div>
                                    </div>
                                    <div className='mt-2'>
                                        <div className='horizontal-line'></div>
                                    </div>
                                </div>}

                                {item.tableName === "contact" && item.fieldName === "name" && <div className={`product-history-doc ${reduceFont ? 'reduce-font' : 'mb-2'}`}>
                                    <div className={`product-history-title ${reduceFont ? 'reduce-font' : ''}`}>
                                        {gethistoryIcon(item.tableName, item.fieldName)}
                                        <div className={`history-mapping-name ${reduceFont ? 'reduce-font' : ''}`}>
                                            {getTitleName(item, item.fieldName)}
                                        </div>
                                    </div>
                                    <div>
                                        <div className='horizontal-line'></div>
                                    </div>
                                </div>}

                                {item.tableName === "funnel" && item.fieldName === 'stageId' && (
                                    <div className='history-mapping increase-padding'>
                                        <div className={`icon-details ${reduceFont ? 'reduce-font' : ''}`}>
                                            <span className='pre'>{getStageName(item?.oldValue)}</span> {"->"} <span>{getStageName(item?.newValue)}</span>
                                        </div>
                                    </div>
                                )}

                                {item.tableName === "contact" && item.fieldName === "name" && (
                                    <div className='history-mapping increase-padding'>
                                        <div className={`icon-details ${reduceFont ? 'reduce-font' : ''}`}>
                                            <span className='pre'>{item.action === 'delete' ? 'Deleted contact' : 'Added contact'}</span> {"->"} <span>{item.newValue}</span>
                                        </div>
                                    </div>
                                )}


{/* { item.tableName === "funnel" && item.fieldName === "isArchived" && <div className={`product-history-doc ${reduceFont ? 'reduce-font' : 'mb-2'}`}>
                                    <div className={`product-history-title ${reduceFont ? 'reduce-font' : ''}`}>
                                        {gethistoryIcon(item.tableName, item.fieldName)}
                                        <div className={`history-mapping-name ${reduceFont ? 'reduce-font' : ''}`}>
                                           This funnel was archived
                                        </div>
                                    </div>
                                    <div>
                                        <div className='horizontal-line'></div>
                                    </div>
                                </div>} */}
                                {item.tableName === "funnel" && item.fieldName === "dealSize" && <div className='history-mapping increase-padding'>
                                    <div className={`icon-details ${reduceFont ? 'reduce-font' : ''}`}>
                                        {item.action === 'upsert' && (
                                            <>
                                                <span>{Utils.convertDealSize(Number(item?.oldValue))}</span> {"-> "}
                                            </>
                                        )}
                                        <span className="pro">{Utils.convertDealSize(Number(item?.newValue))}</span>
                                    </div>

                                </div>}

                                {
                                    item.tableName === "funnel" && item.fieldName === 'comments' && (
                                        <div className='history-mapping increase-padding'>
                                            <div className={`icon-details-c ${reduceFont ? 'reduce-font' : ''}`}>
                                                <span className='pre'>{item?.oldValue}</span> {`->`} <span className='post'>{item?.newValue}</span>
                                            </div>
                                        </div>
                                    )

                                }

                                {item.tableName === "funnel" && item.fieldName === 'followUpDate' && (
                                    <div className='history-mapping increase-padding'>
                                        <div className={`icon-details ${reduceFont ? 'reduce-font' : ''}`}>
                                            <span className='pre'>{item?.oldValue ? Utils.formatAnyDate(item?.oldValue) : ''}</span> {"->"} <span>{item?.newValue ? Utils.formatAnyDate(item?.newValue) : ''}</span>
                                        </div>
                                    </div>
                                )}

                                {item.tableName === "funnel" && item.fieldName === 'coverageDate' && <div className='history-mapping increase-padding'>
                                    <div className={`icon-details ${reduceFont ? 'reduce-font' : ''}`}>
                                        <span className='pre'>{item?.oldValue? Utils.formatAnyDate(item?.oldValue) : ''}</span> {`->`} <span>{item?.newValue ?Utils.formatAnyDate(item?.newValue) : ''}</span>
                                    </div>

                                </div>}


                                


                            </div>
                        ));
                    }
                })}


            </>
        );
    };


    return (
        <>  {getAllFunnelHistoryDetails(details)}
        </>
    );
};




export default FullHistoryComponent;
